<div class="table-responsive">
  <!-- TABLEAU QUI AFFICHE LA LISTE DES DOCUMENTS -->
  <table *ngIf="model.LstDocuments && model.LstDocuments.length > 0" class="table">
    <thead class="noBorder">
      <tr>
        <th>&nbsp;</th>
        <th class="p-0">Titre</th>
        <th class="p-0">Type</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let document of model.LstDocuments" class="noBorder">
        <!-- ICONE POUR TELECHARGER LE FICHIER EN PDF -->
        <td class="m-0 p-0"><i (click)="DownloadDocument(document)" class="fas fa-file-download pointer q-c-main"></i></td>
        <td class="fontSize align-middle m-0 p-0">{{document.Titre}}</td>
        <td class="fontSize align-middle m-0 p-0">{{document.Type}}</td>
      </tr>
    </tbody>
  </table>
</div>
<!-- BOUTON REDIRECTION VERS L'ONGLET DOCUMENTS -->
<p class="mt-2"><a [routerLink]="['../','document']" class="text-dark">Voir tous les documents</a></p>
